var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "automation-prefilters",
    },
    [
      _c(
        "div",
        { staticClass: "toolbar-header" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("automation.executionRules")))]),
          _vm._v(" "),
          _c("SupsisButton", {
            attrs: { ghost: "", icon: "close" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "toolbar-body" },
        [
          _c("div", { staticClass: "info-box" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("automation.preFilterInfo")))]),
          ]),
          _vm._v(" "),
          _c("PreFilterConfig", {
            attrs: { automation: _vm.automation },
            model: {
              value: _vm.preFilters,
              callback: function ($$v) {
                _vm.preFilters = $$v
              },
              expression: "preFilters",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "toolbar-actions" },
            [
              _c(
                "SupsisButton",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.cancelText")))]
              ),
              _vm._v(" "),
              _c(
                "SupsisButton",
                { attrs: { primary: "" }, on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("message.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }